import { render, staticRenderFns } from "./MobileSidebarElement.vue?vue&type=template&id=59b57e01&"
import script from "./MobileSidebarElement.vue?vue&type=script&lang=js&"
export * from "./MobileSidebarElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports